import { isObject } from 'lodash';
import { ACTIONS } from '../Constants';

export const setLocalStorage = (params) => {
    const { dispatchDisabled, key, value = '' } = params;
    const storedValues = window.localStorage.getItem(key) || {};
    let valueToSet = value;

    if (isObject(value)) {
        let parsedStoredValues = storedValues;
        try {
            parsedStoredValues = JSON.parse(storedValues);
            valueToSet = JSON.stringify({ ...parsedStoredValues, ...value });
        } catch (err) {
            valueToSet = JSON.stringify(value);
        }
    }
    if (dispatchDisabled) {
        return window.localStorage.setItem(key, valueToSet);
    }

    return (dispatch) => {
        window.localStorage.setItem(key, valueToSet);
        dispatch({
            type: ACTIONS.SET_LOCAL_STORAGE,
            payload: {
                localStorage: { [key]: value }
            }
        });
    };
};

export const getLocalStorage = (params) => {
    const { dispatchDisabled, key } = params;
    const value = window.localStorage.getItem(key);
    let retrievedValue = value;

    try {
        retrievedValue = JSON.parse(value);
    } catch (err) {
        retrievedValue = value;
    }

    if (dispatchDisabled) {
        return retrievedValue;
    }
    return (dispatch) => {
        const value = retrievedValue || '';
        dispatch({
            type: ACTIONS.GET_LOCAL_STORAGE,
            payload: {
                localStorage: { [key]: value }
            }
        });
        return value;
    };
};
